import React from 'react'
import MaterialSymbol from '../material-symbol'

const Percent = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="percent" {...props} />
))

Percent.displayName = 'Percent'

export default Percent
